import { debugError, debugWarn, debugInfo, debugDebug } from "./utils/debug";

// MSAL configuration for Microsoft authentication
export const msalConfig = {
  auth: {
    clientId: import.meta.env.REACT_APP_MICROSOFT_CLIENT_ID || "",
    authority: import.meta.env.REACT_APP_AZURE_TENANT_ID
      ? `https://login.microsoftonline.com/${import.meta.env.REACT_APP_AZURE_TENANT_ID}`
      : "https://login.microsoftonline.com/common",
    redirectUri: `${window.location.origin}/`,
    postLogoutRedirectUri: `${window.location.origin}/`,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "localStorage" as const,
    storeAuthStateInCookie: true,
  },
  system: {
    allowRedirectInIframe: false,
    windowHashTimeout: 60000,
    iframeHashTimeout: 60000,
    loadFrameTimeout: 60000,
    loggerOptions: {
      loggerCallback: (level: number, message: string, containsPii: boolean) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case 0:
            debugError("[MSAL Error]", message);
            return;
          case 1:
            debugWarn("[MSAL Warn]", message);
            return;
          case 2:
            debugInfo("[MSAL Info]", message);
            return;
          case 3:
            debugDebug("[MSAL Debug]", message);
            return;
          default:
            return;
        }
      },
      logLevel: 2,
    },
  },
};

// Login Request Scopes - includes API scope to trigger consent during login
export const loginRequest = {
  scopes: ["User.Read", import.meta.env.REACT_APP_API_SCOPE].filter(Boolean) as string[],
};

// API Request Scopes for backend authentication
export const apiRequest = {
  scopes: [import.meta.env.REACT_APP_API_SCOPE || "User.Read"],
};

// Microsoft provider config
export const authProviders = {
  microsoft: {
    logo: "https://cdn-icons-png.flaticon.com/512/732/732221.png",
    name: "Microsoft",
  },
};
